"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsLoading = exports.resultSagas = void 0;
var effects_1 = require("redux-saga/effects");
var ResultAction_1 = require("@/pages/search/actions/sfilter/ResultAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var SearchQueryCallSaga_1 = require("@/pages/search/sagas/SearchQueryCallSaga");
var stateToSearchQuery_1 = require("@/transformers/stateToSearchQuery");
var HfilterAction_1 = require("@/pages/search/actions/HfilterAction");
var RootSearchMapSaga_1 = require("@/pages/search/sagas/RootSearchMapSaga");
var getIsLoading = function (state) { return state.results.isLoading; };
exports.getIsLoading = getIsLoading;
var getCurrentPageInfo = function (state) {
    if (!state.results.resultResponses.length)
        return { page: 0, pageTotal: 0 };
    return {
        page: state.results.resultResponses[state.results.resultResponses.length - 1].page,
        pageTotal: state.results.resultResponses[state.results.resultResponses.length - 1].pageTotal,
    };
};
var getSaveSearchCount = function (state) {
    return state.sfav.sectionSavedSearch.items.length;
};
var watchCheckScrollEnd = function () {
    var scrollable;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.CHECK_SCROLLEND)];
            case 1:
                _a.sent();
                scrollable = document.getElementsByTagName('html')[0];
                if (scrollable.scrollTop + document.body.clientHeight === document.getElementsByClassName('l-search')[0].clientHeight) {
                    scrollable.scrollTop = scrollable.scrollTop - document.body.clientHeight * 0.2;
                }
                return [3 /*break*/, 0];
            case 2: return [2 /*return*/];
        }
    });
};
var watchLoadNextPage = function () {
    var _a, page, pageTotal;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.LOAD_NEXT_PAGE)];
            case 1:
                _b.sent();
                return [4 /*yield*/, effects_1.select(getCurrentPageInfo)];
            case 2:
                _a = _b.sent(), page = _a.page, pageTotal = _a.pageTotal;
                if (!(page < pageTotal)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.loadPage(page + 1))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchLoadPage = function () {
    var payload, searchQuery, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.LOAD_PAGE)];
            case 1:
                payload = (_c.sent()).payload;
                _a = effects_1.call;
                _b = [stateToSearchQuery_1.stateToSearchQuery];
                return [4 /*yield*/, effects_1.select()];
            case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            case 3:
                searchQuery = _c.sent();
                searchQuery.pageNumber = payload;
                return [4 /*yield*/, effects_1.call(SearchQueryCallSaga_1.doSearch, searchQuery)];
            case 4:
                _c.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchOnChangePage = function () {
    var payload, searchQuery, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_CHANGE_PAGE)];
            case 1:
                payload = (_c.sent()).payload;
                return [4 /*yield*/, effects_1.call(WindowApi_1.scrollToSearchTop)];
            case 2:
                _c.sent();
                _a = effects_1.call;
                _b = [stateToSearchQuery_1.stateToSearchQuery];
                return [4 /*yield*/, effects_1.select()];
            case 3: return [4 /*yield*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            case 4:
                searchQuery = _c.sent();
                searchQuery.pageNumber = payload;
                return [4 /*yield*/, effects_1.call(SearchQueryCallSaga_1.doSearch, searchQuery)];
            case 5:
                _c.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchOnNewSearch = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_RESULT_NEW_SEARCH)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onClearClick())];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onClearBoundaryClick())];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchOnClearDistrict = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_CLEAR_DISTRICT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onDistrictClear())];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onSearchClick())];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchOnBackToDistrict = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_BACK_TO_DISTRICT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(RootSearchMapSaga_1.zoomToDistrict)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnSaveSearchClicked = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_RESULT_SAVE_SEARCH_CLICK)];
            case 1:
                _a.sent();
                // yield put(SlabelAction.onSaveClick());
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.onSaveSearchClose())];
            case 2:
                // yield put(SlabelAction.onSaveClick());
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSetResultPage = function () {
    var payload, saveSearchCount;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.SET_RESULT_PAGE)];
            case 1:
                payload = (_a.sent()).payload;
                if (!payload.page)
                    return [3 /*break*/, 0];
                if (!(payload.page % 2 === 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.select(getSaveSearchCount)];
            case 2:
                saveSearchCount = _a.sent();
                if (!(saveSearchCount === 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.showSaveSearchPrompt(payload.page))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchResultPageDomLoaded = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.onUpdateLastItemPosition())];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.onUpdateInfiniteLoadEnable())];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var resultSagas = {
    watchOnChangePage: watchOnChangePage,
    watchCheckScrollEnd: watchCheckScrollEnd,
    watchLoadNextPage: watchLoadNextPage,
    watchLoadPage: watchLoadPage,
    watchOnNewSearch: watchOnNewSearch,
    watchOnSaveSearchClicked: watchOnSaveSearchClicked,
    watchSetResultPage: watchSetResultPage,
    watchResultPageDomLoaded: watchResultPageDomLoaded,
    watchOnClearDistrict: watchOnClearDistrict,
    watchOnBackToDistrict: watchOnBackToDistrict,
};
exports.resultSagas = resultSagas;
